import { createDefaultRule } from "./types";

/**
 * Keep rules aligned with the current tools list:
 * - Drop references to removed tools
 * - Ensure at least one enabled rule when tools exist
 * - Default empty IF conditions to "true" when tools are referenced
 */
export const syncAgentRulesWithActions = (agent) => {
  if (!agent || typeof agent !== "object") return agent;

  const actions = agent.actions || [];
  const actionIds = actions.map((a) => a?.action_id).filter(Boolean);
  const actionIdSet = new Set(actionIds);

  if (actionIds.length === 0) {
    return {
      ...agent,
      rules: (agent.rules || []).map((rule) =>
        rule ? { ...rule, action_ids: [] } : rule
      ),
    };
  }

  let rules = (agent.rules || []).map((rule) => {
    if (!rule) return rule;
    const kept = (rule.action_ids || []).filter((id) => actionIdSet.has(id));
    const action_ids = kept.length > 0 ? kept : [...actionIds];
    const next = { ...rule, action_ids };
    if (action_ids.length > 0 && (!next.if || !String(next.if).trim())) {
      next.if = "true";
    }
    return next;
  });

  const enabledRules = rules.filter((r) => r && r.enabled !== false);
  if (enabledRules.length === 0) {
    const base = createDefaultRule(actionIds[0]);
    rules = [
      {
        ...base,
        name: base.name || "Run tools",
        if: "true",
        action_ids: [...actionIds],
        enabled: true,
      },
    ];
  }

  return { ...agent, rules };
};
